var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2722 4.87372C10.2722 4.87372 9.95547 8.33064 9.77172 9.78681C9.68422 10.4823 9.19597 10.8898 8.39622 10.9027C6.87431 10.9268 5.35064 10.9283 3.82931 10.9001C3.05989 10.8863 2.57981 10.4736 2.49406 9.7904C2.30914 8.3214 1.99414 4.87372 1.99414 4.87372",
    stroke: "#E04F5F",
    strokeWidth: 1.46071,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0797 3.2166H1.1875",
    stroke: "#E04F5F",
    strokeWidth: 1.46071,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17383 3.21661C8.71592 3.21661 8.32158 2.93174 8.23175 2.53703L8.09 1.91288C8.0025 1.62493 7.70617 1.42578 7.36842 1.42578H4.89917C4.56142 1.42578 4.26508 1.62493 4.17758 1.91288L4.03583 2.53703C3.946 2.93174 3.55167 3.21661 3.09375 3.21661",
    stroke: "#E04F5F",
    strokeWidth: 1.46071,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.b282a873a5f44408a593645f634864a3.svg";
export { ForwardRef as ReactComponent };